import { initLoadMore } from "./loadmore-articles";
import { initLoadMoreRelated } from "./loadmore-related-articles";
import { initNavigation } from "./navigation";

jQuery(document).ready(function () {
  AOS.init({
    duration: 800,
    once: true,
    offset: 100,
  });

  initNavigation();
  initLoadMore();
  initLoadMoreRelated();

  document.documentElement.classList.add("js-enabled");
});
